import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface IEditEventMediaItem {
  _id: string;
  url: string;
  urlLarge?: string;
  urlMedium?: string;
  type: 'image' | 'video';
}

export interface IEditEventUser {
  _id: string;
  displayName: string;
  userName: string;
  profileImage: { urlSmall?: string } | null;
  collabStatus?: 'ACCEPTED' | 'PENDING' | 'DECLINED';
}

export interface IEditEventRequest {
  eventId: string;
  title?: string;
  description?: string;
  startDate?: string;
  endDate?: string;
  genreOfEvent?: string;
  location?: string;
  minPrice?: string;
  maxPrice?: string;
  currency?: string;
  linkToBookingSite?: string;
  hashtags?: string[];
  isExternal?: boolean;
  externalLink?: string;
  taggedPeople?: IEditEventUser[];
  collaborators?: IEditEventUser[];
  existingMedia?: IEditEventMediaItem[];
}

@Injectable({ providedIn: 'root' })
export class EditEventService {
  private editRequest$ = new Subject<IEditEventRequest>();
  readonly onEditRequest$ = this.editRequest$.asObservable();

  openEditModal(req: IEditEventRequest): void {
    this.editRequest$.next(req);
  }
}
